<template>
  <div
    id="frequencia-container"
    v-if="!carregando"
  >
    <Breadcrumb :items="breadcrumbItems" />
    <div class="infos-encontro-container">
      <h4>FREQUÊNCIA {{ dadosEncontros?.titulo.toUpperCase() }}</h4>
      <div class="infos-encontro">
        <p>Modalidade de Execução: {{ dadosAtividade?.modalidade }}</p>
        <p>
          Data da Realização: {{ formatarData(dadosEncontros?.inicio_periodo) }}
        </p>
        <p>
          Horáriro da Realização:
          {{ formatarDataHora(dadosEncontros?.inicio_periodo).split(" ")[1] }}
        </p>
      </div>
    </div>
    <div class="opcoes-selecao">
      <!-- Summary -->
      <div class="summary">
        <div class="summary-item">
          <span class="dot presente"></span>
          Presentes: <strong>{{ presenteCount }}</strong>
        </div>
        <div class="summary-item">
          <span class="dot falta"></span>
          Faltas: <strong>{{ faltaCount }}</strong>
        </div>
        <div class="summary-item">
          <span class="dot pendente"></span>
          Pendentes: <strong>{{ pendenteCount }}</strong>
        </div>
      </div>
      <div
        class="options"
        v-if="dadosEncontros?.status === 'EM_EXECUCAO'"
      >
        <div>
          <input
            id="todos-presentes"
            type="radio"
            name="estado-todos"
            v-model="statusTodos"
            value="presente"
          />
          <label for="todos-presentes">Todos presentes</label>
        </div>

        <div>
          <input
            id="todos-faltaram"
            type="radio"
            name="estado-todos"
            v-model="statusTodos"
            value="falta"
          />
          <label for="todos-faltaram">Todos faltaram</label>
        </div>
      </div>
      <div
        v-else-if="
          temFrequenciaRegistrada && dadosEncontros?.status === 'FINALIZADO'
        "
        class="status-message"
      >
        <p>
          ✓ Encontro finalizado. Frequência já foi registrada. Visualização
          apenas.
        </p>
      </div>
    </div>
    <div class="wrapper">
      <!-- Mini formulário para CPF ou E-mail (Apenas para modalidade sem inscrição mas com frequência) -->
      <div
        v-if="
          dadosAtividade?.modalidadeInscricao ===
            'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA' &&
          dadosEncontros?.status === 'EM_EXECUCAO'
        "
        class="mini-form-container"
      >
        <h5>Adicionar Participante</h5>
        <div class="busca-tipo-selector">
          <label class="radio-selector">
            <input
              type="radio"
              v-model="tipoPesquisa"
              value="cpf"
            />
            <span>CPF</span>
          </label>
          <label class="radio-selector">
            <input
              type="radio"
              v-model="tipoPesquisa"
              value="email"
            />
            <span>E-mail</span>
          </label>
        </div>
        <div class="search-box">
          <input
            v-if="tipoPesquisa === 'cpf'"
            type="text"
            class="input-search"
            placeholder="000.000.000-00"
            v-model="cpfPesquisa"
            v-maska="'###.###.###-##'"
            @keyup.enter="buscarParticipante"
          />
          <input
            v-else
            type="email"
            class="input-search"
            placeholder="email@exemplo.com"
            v-model="emailPesquisa"
            @keyup.enter="buscarParticipante"
          />
          <button
            class="btn-buscar"
            @click.prevent="buscarParticipante"
            :disabled="buscando"
          >
            {{ buscando ? "Buscando..." : "Buscar" }}
          </button>
        </div>

        <!-- Retângulo do participante encontrado ou não cadastrado -->
        <div
          v-if="usuarioEncontrado"
          class="participante-resultado-card animate-fade-in"
        >
          <div class="info">
            <span class="label">Participante:</span>
            <strong class="nome">{{ usuarioEncontrado.nome }}</strong>
            <span
              v-if="usuarioEncontrado.cpf"
              class="identificador-detalhe"
              >({{ formatarCPFMascarado(usuarioEncontrado.cpf) }})</span
            >
            <span
              v-else
              class="identificador-detalhe"
              >({{ usuarioEncontrado.email }})</span
            >
          </div>
          <button
            class="btn-adicionar-lista"
            @click.prevent="adicionarUsuarioEncontrado"
          >
            Adicionar à Lista
          </button>
        </div>
      </div>

      <div
        class="table-container"
        v-if="
          participantes.length > 0 ||
          dadosAtividade?.modalidadeInscricao !==
            'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
        "
      >
        <table class="attendance-table">
          <thead>
            <tr>
              <th class="col-name">Nome do participante</th>
              <th
                v-if="
                  dadosAtividade?.modalidadeInscricao !==
                  'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
                "
                class="col-email"
              >
                E-mail
              </th>
              <th
                v-else
                class="col-cpf"
              >
                CPF / E-mail
              </th>
              <th class="col-status">Presente</th>
              <th class="col-status">Falta</th>
              <th class="col-status">Pendente</th>
              <th
                v-if="
                  dadosAtividade?.modalidadeInscricao ===
                  'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
                "
                class="col-acoes"
              >
                Remover
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(participante, index) in participantes"
              :key="
                participante.participanteId ||
                participante.id ||
                participante.cpf ||
                participante.email ||
                index
              "
              :class="{
                'row-even': index % 2 === 0,
                'row-odd': index % 2 !== 0,
              }"
            >
              <td class="col-name">
                <span v-if="participante.nome">{{ participante.nome }}</span>
                <span
                  v-else
                  class="placeholder"
                  >Nome do participante</span
                >
              </td>
              <td
                v-if="
                  dadosAtividade?.modalidadeInscricao !==
                  'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
                "
                class="col-email"
              >
                <span v-if="participante.email">{{ participante.email }}</span>
                <span
                  v-else
                  class="placeholder"
                  >usuario@email.com</span
                >
              </td>
              <td
                v-else
                class="col-cpf"
              >
                <span v-if="participante.cpf">{{
                  formatarCPFMascarado(participante.cpf)
                }}</span>
                <span v-else-if="participante.email">{{
                  participante.email
                }}</span>
                <span v-else>-</span>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input
                    type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    value="presente"
                    v-model="participante.status"
                    :disabled="dadosEncontros?.status === 'FINALIZADO'"
                  />
                  <span
                    class="custom-radio"
                    :class="{ selected: participante.status === 'presente' }"
                  ></span>
                </label>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input
                    type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    value="falta"
                    v-model="participante.status"
                    :disabled="dadosEncontros?.status === 'FINALIZADO'"
                  />
                  <span
                    class="custom-radio"
                    :class="{
                      selected: participante.status === 'falta',
                      falta: participante.status === 'falta',
                    }"
                  ></span>
                </label>
              </td>
              <td class="col-status center">
                <label class="radio-label">
                  <input
                    type="radio"
                    :name="`status-${participante.participanteId || participante.id || participante.cpf || participante.email || index}`"
                    :value="null"
                    v-model="participante.status"
                    :disabled="dadosEncontros?.status === 'FINALIZADO'"
                  />
                  <span
                    class="custom-radio"
                    :class="{
                      selected: participante.status === null,
                      pendente: participante.status === null,
                    }"
                  ></span>
                </label>
              </td>
              <td
                v-if="
                  dadosAtividade?.modalidadeInscricao ===
                  'NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA'
                "
                class="col-status center"
              >
                <button
                  class="btn-remover"
                  @click.prevent="removerParticipanteLista(index)"
                  :disabled="dadosEncontros?.status === 'FINALIZADO'"
                >
                  <span class="trash-icon">🗑️</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table-container-empty"
        v-else
      >
        <p>Nenhum participante adicionado para frequência neste encontro.</p>
      </div>
    </div>
    <div class="botoes-container">
      <button
        v-if="dadosEncontros?.status === 'EM_EXECUCAO'"
        class="btn-salvar"
        @click="salvarFrequencia"
      >
        Salvar Frequência
      </button>
      <button
        class="btn-voltar"
        @click="voltarAtividade"
      >
        Voltar
      </button>
    </div>
  </div>
  <Carregamento
    v-else
    :mensagemCarregamento="'Carregando Frequência'"
  />
</template>
<script setup>
import router from "@/router";
import acaoService from "@/service/acaoService";
import atividadeService from "@/service/atividadeService";
import encontrosService from "@/service/encontrosService";
import participantesAtividadeService from "@/service/participantesAtividadeService";
import frequenciaService from "@/service/frequenciaService";
import usuariosService from "@/service/usuariosService";
import {
  formatarData,
  formatarDataHora,
  getLocalDateTime,
  formatarCPF,
  formatarCPFMascarado,
} from "@/utils/FormatarEntradas";
import { onMounted, ref, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { vMaska } from "maska";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const route = useRoute();

const dadosAcao = ref(null);
const dadosAtividade = ref(null);
const dadosEncontros = ref(null);
const carregando = ref(true);
const statusTodos = ref(null);
const participantes = ref([]);
const frequenciasExistentes = ref([]);
const temFrequenciaRegistrada = ref(false);

// Estados para pesquisa de participante
const tipoPesquisa = ref("cpf"); // "cpf" ou "email"
const cpfPesquisa = ref("");
const emailPesquisa = ref("");
const buscando = ref(false);
const usuarioEncontrado = ref(null);

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
    { tipo: "acao", id: route.params.id, to: `/acao/${route.params.id}` },
    { label: "Atividades", to: `/acao/${route.params.id}/atividades` },
    {
      label: "Realizar Frequência",
      to: `/acao/${route.params.id}/cadastro-frequencia/${route.params.encontroId}`,
    },
  ];
});

async function carregarAcao() {
  dadosAcao.value = await acaoService.getAcoesById(route.params.id);
}

async function carregarAtividade() {
  dadosAtividade.value = await atividadeService.getAtividadeId(
    route.params.atividadeId
  );
}

async function carregarEncontro() {
  const response = await encontrosService.getEncontros(
    0,
    100,
    route.params.atividadeId
  );

  response.forEach((encontro) => {
    if (encontro.encontroId === route.params.encontroId) {
      dadosEncontros.value = encontro;
    }
  });

  carregando.value = false;
}

async function carregarPartcipantes() {
  // Se não necessita inscrição, a lista começa vazia para adicionarmos os CPFs/E-mails.
  if (
    dadosAtividade.value?.modalidadeInscricao ===
    "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA"
  ) {
    participantes.value = [];
    return;
  }

  participantes.value =
    await participantesAtividadeService.getParticipantesAtividade(
      0,
      1000,
      route.params.atividadeId
    );

  participantes.value.forEach((participante) => {
    participante.status = null;
  });
}

async function carregarFrequenciasExistentes() {
  try {
    const frequencias = await frequenciaService.getFrequencia(
      route.params.encontroId
    );

    if (frequencias && frequencias.length > 0) {
      frequenciasExistentes.value = frequencias;

      // Somente marcar como temFrequenciaRegistrada se encontro estiver FINALIZADO
      // Se estiver EM_EXECUCAO, permite edição
      if (dadosEncontros.value?.status === "FINALIZADO") {
        temFrequenciaRegistrada.value = true;
      }

      const modalidadeInscricao = dadosAtividade.value?.modalidadeInscricao;

      if (modalidadeInscricao === "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA") {
        participantes.value = frequencias.map((freq) => {
          let status = null;
          if (freq.statusFrequencia === "PRESENCA") {
            status = "presente";
          } else if (freq.statusFrequencia === "FALTA") {
            status = "falta";
          }

          return {
            id: freq.participanteId,
            participanteId: freq.participanteId,
            nome: freq.nomeParticipante,
            cpf: freq.cpf,
            email: freq.email,
            status: status,
          };
        });
      } else {
        // Pré-preencher os status dos participantes com base nas frequências existentes
        participantes.value.forEach((participante) => {
          const frequenciaEncontrada = frequencias.find((freq) => {
            // Verificar se é frequência com inscrição (participanteId) ou sem (cpf/email/matricula/siap)
            if (freq.participanteId && participante.participanteId) {
              return freq.participanteId === participante.participanteId;
            }
            return false;
          });

          if (frequenciaEncontrada) {
            // Verificar o statusFrequencia do payload
            if (frequenciaEncontrada.statusFrequencia === "NAO_LANCADA") {
              participante.status = null;
            } else if (frequenciaEncontrada.statusFrequencia === "FALTA") {
              participante.status = "falta";
            } else if (frequenciaEncontrada.statusFrequencia === "PRESENCA") {
              participante.status = "presente";
            } else {
              participante.status = null;
            }
          } else {
            participante.status = null;
          }
        });
      }
    }
  } catch (error) {
    console.warn("Erro ao carregar frequências existentes:", error);
  }
}

// Funções de busca e manipulação de participantes no mini-formulário
function getProximoNomeNaoCadastrado() {
  let maxNum = 0;
  participantes.value.forEach((p) => {
    if (p.nome && p.nome.startsWith("usuarioNaoCadastrado")) {
      const numStr = p.nome.replace("usuarioNaoCadastrado", "");
      const num = parseInt(numStr, 10);
      if (!isNaN(num) && num > maxNum) {
        maxNum = num;
      }
    }
  });
  return `usuarioNaoCadastrado${maxNum + 1}`;
}

async function buscarParticipante() {
  const cpf = tipoPesquisa.value === "cpf" ? cpfPesquisa.value : "";
  const email = tipoPesquisa.value === "email" ? emailPesquisa.value : "";

  if (tipoPesquisa.value === "cpf") {
    const cleanCpf = cpf.replace(/\D/g, "");
    if (cleanCpf.length !== 11) {
      alert("Por favor, digite um CPF válido.");
      return;
    }

    // Verificar se já está na lista local
    const jaExiste = participantes.value.some((p) => p.cpf === cleanCpf);
    if (jaExiste) {
      alert("Este CPF já está adicionado na lista.");
      return;
    }
  } else {
    const emailTrim = email.trim();
    if (!emailTrim || !emailTrim.includes("@")) {
      alert("Por favor, digite um e-mail válido.");
      return;
    }

    // Verificar se já está na lista local
    const jaExiste = participantes.value.some(
      (p) => p.email && p.email.toLowerCase() === emailTrim.toLowerCase()
    );
    if (jaExiste) {
      alert("Este e-mail já está adicionado na lista.");
      return;
    }
  }

  buscando.value = true;
  usuarioEncontrado.value = null;

  try {
    const user = await usuariosService.getUsuarioPorCpfOuEmail(
      cpf,
      email,
      route.params.atividadeId
    );

    if (user) {
      usuarioEncontrado.value = {
        id: user.id,
        nome: user.nome,
        cpf: user.cpf,
        email: user.email,
        jaExisteBD: true,
      };
    } else {
      const nomeTemp = getProximoNomeNaoCadastrado();
      usuarioEncontrado.value = {
        nome: nomeTemp,
        cpf: tipoPesquisa.value === "cpf" ? cpf.replace(/\D/g, "") : null,
        email: tipoPesquisa.value === "email" ? email.trim() : null,
        jaExisteBD: false,
      };
    }
  } catch (error) {
    console.error("Erro ao buscar participante:", error);
    alert("Ocorreu um erro ao buscar o participante.");
  } finally {
    buscando.value = false;
  }
}

function adicionarUsuarioEncontrado() {
  if (!usuarioEncontrado.value) return;

  participantes.value.push({
    id: usuarioEncontrado.value.id || null,
    nome: usuarioEncontrado.value.nome,
    cpf: usuarioEncontrado.value.cpf || null,
    email: usuarioEncontrado.value.email || null,
    status: null,
  });

  usuarioEncontrado.value = null;
  cpfPesquisa.value = "";
  emailPesquisa.value = "";
}

function removerParticipanteLista(index) {
  participantes.value.splice(index, 1);
}

const presenteCount = computed(
  () => participantes.value.filter((p) => p.status === "presente").length
);
const faltaCount = computed(
  () => participantes.value.filter((p) => p.status === "falta").length
);
const pendenteCount = computed(
  () => participantes.value.filter((p) => p.status === null).length
);

onMounted(async () => {
  await carregarAcao();
  await carregarAtividade();
  await carregarPartcipantes();
  await carregarEncontro();

  // Carregar frequências existentes após carregar os participantes
  await carregarFrequenciasExistentes();
});

watch(statusTodos, (newVal) => {
  if (newVal === "presente") {
    participantes.value.forEach((participant) => {
      participant.status = "presente";
    });
  } else if (newVal === "falta") {
    participantes.value.forEach((participant) => {
      participant.status = "falta";
    });
  } else if (newVal === "pendente") {
    participantes.value.forEach((participant) => {
      participant.status = null;
    });
  }
});

async function salvarFrequencia() {
  // Validar se todos os participantes têm status definido (não podem estar pendentes)
  const pendentes = participantes.value.filter((p) => p.status === null);
  if (pendentes.length > 0) {
    alert(
      `Por favor, defina o status de presença/falta para TODOS os ${pendentes.length} participante(s) pendente(s). Não é permitido salvar frequência com status pendente.`
    );
    return;
  }

  try {
    // Verificar se é atividade com inscrição ou sem inscrição
    const modalidadeInscricao = dadosAtividade.value?.modalidadeInscricao;
    const encontroId = route.params.encontroId;
    const dataHoraRegistro = getLocalDateTime(new Date(), "BR");

    let frequenciasEnviadas = 0;
    let erros = [];

    // Se for SEM INSCRIÇÃO, usar CPF/Email/Matricula/SIAP
    if (
      modalidadeInscricao === "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA" ||
      modalidadeInscricao === "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA"
    ) {
      for (const participante of participantes.value) {
        // Não enviar frequências pendentes
        if (participante.status === null) {
          continue;
        }

        // Validar que pelo menos um identificador está preenchido
        const temIdentificador =
          participante.cpf ||
          participante.email ||
          participante.matricula ||
          participante.siap;

        if (!temIdentificador) {
          erros.push(
            `Participante sem CPF, Email, Matrícula ou SIAP não pode ser registrado`
          );
          continue;
        }

        // Mapear status para statusFrequencia
        const statusFrequencia =
          participante.status === "presente" ? "PRESENCA" : "FALTA";

        // Envolver no objeto frequenciaSemInscricao
        const payload = {
          frequenciaSemInscricao: {
            cpf: participante.cpf || null,
            email: participante.email || null,
            matricula: participante.matricula || null,
            siap: participante.siap || null,
            dataHoraRegistro: dataHoraRegistro,
            statusFrequencia: statusFrequencia,
          },
        };

        try {
          await frequenciaService.postFrequencia(payload, encontroId);
          frequenciasEnviadas++;
        } catch (error) {
          console.warn(
            `Erro ao registrar frequência para ${participante.email}:`,
            error
          );
          erros.push(
            `Erro ao registrar ${participante.email || "participante"}`
          );
        }
      }
    } else {
      // Se for COM INSCRIÇÃO, usar participanteId
      for (const participante of participantes.value) {
        // Não enviar frequências pendentes
        if (participante.status === null) {
          continue;
        }

        // Validar que participanteId existe
        if (!participante.participanteId) {
          console.warn(`Participante ${participante.nome} sem ID`);
          continue;
        }

        // Mapear status para statusFrequencia
        const statusFrequencia =
          participante.status === "presente" ? "PRESENCA" : "FALTA";

        // Envolver no objeto frequenciaComInscricao
        const payload = {
          frequenciaComInscricao: {
            participanteId: participante.participanteId,
            dataHoraRegistro: dataHoraRegistro,
            statusFrequencia: statusFrequencia,
          },
        };

        try {
          await frequenciaService.postFrequencia(payload, encontroId);
          frequenciasEnviadas++;
        } catch (error) {
          console.warn(
            `Erro ao registrar frequência para ${participante.nome}:`,
            error
          );
          erros.push(`Erro ao registrar ${participante.nome}`);
        }
      }
    }

    // Gerar mensagem de feedback
    let mensagem = `Frequência salva! ${frequenciasEnviadas} participante(s) registrado(s).`;
    if (erros.length > 0) {
      mensagem += `\n\nErros encontrados:\n${erros.join("\n")}`;
    }

    alert(mensagem);
    voltarAtividade();
  } catch (error) {
    console.error("Erro ao salvar frequência:", error);
    alert("Erro ao salvar frequência: " + error.message);
  }
}

function voltarAtividade() {
  router.back();
}
</script>
<style lang="css" scoped>
.infos-encontro {
  margin: 10px 0 0 15px;
}

.infos-encontro p {
  margin: 0;
  padding: 0;
}

.opcoes-selecao {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2rem 3rem 10px 3rem;
}

.options {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
}

.wrapper {
  font-family: "DM Sans", sans-serif;
  padding: 0 2rem 2rem 2rem;
  background: #f4f3f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.table-container {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(80, 40, 140, 0.1);
}

.attendance-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

/* HEADER */
thead tr {
  background: #3d2a6e;
}

thead th {
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding: 13px 18px;
  text-align: left;
}

thead th.col-status {
  text-align: center;
}

/* COLUMNS */
.col-name {
  width: 30%;
}

.col-email {
  width: 35%;
}

.col-status {
  width: 11.67%;
}

/* ROWS */
tbody tr {
  transition: background 0.15s;
  border-bottom: 1px solid #ece9f5;
}

tbody tr:last-child {
  border-bottom: none;
}

.row-even {
  background: #fff;
}

.row-odd {
  background: #faf9fd;
}

tbody tr:hover {
  background: #f0ecfa;
}

tbody td {
  padding: 11px 18px;
  font-size: 0.875rem;
  color: #2d2040;
}

tbody td.center {
  text-align: center;
}

.placeholder {
  color: #9e94b8;
}

/* RADIO */
.radio-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.radio-label input[type="radio"] {
  display: none;
}

.custom-radio {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #b0a8cc;
  background: #fff;
  display: inline-block;
  transition:
    border-color 0.18s,
    background 0.18s,
    box-shadow 0.18s;
  position: relative;
}

.custom-radio.selected {
  border-color: #5b3ea8;
  background: #5b3ea8;
  box-shadow: 0 0 0 3px rgba(91, 62, 168, 0.18);
}

.custom-radio.selected::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-radio.falta {
  border-color: #c0392b;
  background: #c0392b;
  box-shadow: 0 0 0 3px rgba(192, 57, 43, 0.15);
}

.custom-radio.pendente {
  border-color: #b0a8cc;
  background: #b0a8cc;
  box-shadow: 0 0 0 3px rgba(176, 168, 204, 0.15);
}

.custom-radio.pendente::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* SUMMARY */
.summary {
  display: flex;
  gap: 1.5rem;
  font-size: 0.875rem;
  color: #4a3d6b;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-item strong {
  color: #2d2040;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot.presente {
  background: #5b3ea8;
}
.dot.falta {
  background: #c0392b;
}
.dot.pendente {
  background: #b0a8cc;
}

/* BOTÕES */
.botoes-container {
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 2rem;
  background: #f4f3f8;
}

.btn-salvar {
  padding: 12px 32px;
  background-color: #5b3ea8;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-salvar:hover {
  background-color: #4a2f87;
}

.btn-voltar {
  padding: 12px 32px;
  background-color: white;
  color: #5b3ea8;
  border: 2px solid #5b3ea8;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-voltar:hover {
  background-color: #f0ecfa;
}

/* Mini formulário */
.mini-form-container {
  background: #ffffff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(80, 40, 140, 0.08);
  border: 1px solid #e1dbf0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.mini-form-container h5 {
  margin: 0;
  color: #3d2a6e;
  font-size: 1.1rem;
  font-weight: 600;
}

.busca-tipo-selector {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 0.25rem;
}

.radio-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #4a3d6b;
  cursor: pointer;
  user-select: none;
}

.radio-selector input[type="radio"] {
  accent-color: #5b3ea8;
  width: 16px;
  height: 16px;
}

.search-box {
  display: flex;
  gap: 0.75rem;
  width: 100%;
}

.input-search {
  flex: 1;
  padding: 10px 14px;
  border: 2px solid #d3cce3;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #2d2040;
  background-color: #faf9fd;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.input-search:focus {
  outline: none;
  border-color: #5b3ea8;
  box-shadow: 0 0 0 3px rgba(91, 62, 168, 0.15);
  background-color: #ffffff;
}

.btn-buscar {
  padding: 10px 24px;
  background-color: #5b3ea8;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: background-color 0.2s;
  min-width: 110px;
}

.btn-buscar:hover:not(:disabled) {
  background-color: #4a2f87;
}

.btn-buscar:disabled {
  background-color: #b0a8cc;
  cursor: not-allowed;
}

/* Card de Resultado da busca */
.participante-resultado-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f0ecfa;
  border: 1px solid #d3cce3;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  margin-top: 0.5rem;
  gap: 1rem;
}

.participante-resultado-card .info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.9rem;
  color: #2d2040;
}

.participante-resultado-card .label {
  color: #5b3ea8;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.participante-resultado-card .nome {
  font-size: 1.05rem;
  color: #2d2040;
}

.participante-resultado-card .identificador-detalhe {
  color: #7b6f93;
  font-family: monospace;
  font-size: 0.85rem;
}

.btn-adicionar-lista {
  padding: 8px 16px;
  background-color: #27ae60;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.btn-adicionar-lista:hover {
  background-color: #219653;
}

/* Animação */
.animate-fade-in {
  animation: fadeIn 0.3s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Ações / Remoção na Tabela */
.btn-remover {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-remover:hover:not(:disabled) {
  background-color: rgba(192, 57, 43, 0.1);
}

.btn-remover:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.trash-icon {
  font-size: 1.1rem;
}

/* placeholders na tabela */
.placeholder {
  color: #9e94b8;
  font-style: italic;
}
</style>
